import styled from 'styled-components';
import YouTube from 'react-youtube';
import { AA_SURFACE } from '~/modules/Helper/contrast.helper';

export const Container = styled.div`
  padding: 20px;
  height: 100%;
  position: relative;
  background: ${AA_SURFACE};
`;

export const Youtube = styled(YouTube)`
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
`;